const financeEn = {
    fineCharges: require("lang/en/finance/FineCharges").default,
    invoice: require("lang/en/finance/Invoice").default,
    payment: require("lang/en/finance/Payment").default,
    expenseBudget: require("lang/en/finance/ExpenseBudget").default,
    budgetTracking: require("lang/en/finance/BudgetTracking").default,
    expense: require("lang/en/finance/Expense").default,
}

export default financeEn;